import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { downloadCSV } from "../../../utils/downloadCSV";
import CSVReader from "../../../components/ImportCsv/CSVReader";
import { getVendorName } from "../../../utils/getVendorName";
import { useBulkExtraBonusPointsMutation } from "../../../features/tenant/rewardify/pointsScanHistory/extraPointsScanHistoryApi";

function parseCSV(string) {
    const csvHeader = string
        .slice(0, string.indexOf("\n"))
        .replace(/\s/g, "")
        .split(",");

    const csvRows = string.slice(string.indexOf("\n") + 1).split(/\r?\n/);

    console.log("csvRows: ", csvRows.length, csvRows);

    const array = csvRows
        .map((row) => {
            const values = [];
            let insideQuotes = false;
            let currentField = "";

            for (let char of row) {
                if (char === "," && !insideQuotes) {
                    values.push(currentField.trim());
                    currentField = "";
                } else if (char === '"') {
                    insideQuotes = !insideQuotes;
                } else {
                    currentField += char;
                }
            }

            values.push(currentField.trim());
            return values;
        })
        .filter((values) => values.length === csvHeader.length)
        .map((values) => {
            const obj = csvHeader.reduce((object, header, index) => {
                object[header] = values[index].trim();
                return object;
            }, {});
            return obj;
        });

    return array;
}

function validateAndCleanObjects(objects) {
    const requiredKeysSet = new Set(["mobile", "points", "remarks"]);

    function isEmptyObject(obj) {
        return Array.from(requiredKeysSet).every(
            (key) => !obj[key]?.toString().trim(),
        );
    }

    const cleanedObjects = [];

    for (const object of objects) {
        const newObject = {};
        let valid = true;

        const mobile = object["mobile"]?.toString().trim();
        const value = object["points"]?.toString().trim();
        const remarks = object["remarks"]?.toString().trim();

        if (isEmptyObject(object)) continue;

        if (!mobile || !/^\d{10}$/.test(mobile)) {
            valid = false;
        }

        const parsedPoints = parseFloat(value);
        if (!value || isNaN(parsedPoints) || parsedPoints == 0) {
            valid = false;
        }

        newObject.mobile = mobile;
        newObject.value = parsedPoints;
        newObject.remarks = remarks;
        newObject.status = valid ? 1 : 2;

        cleanedObjects.push(newObject);
    }

    const isValid = cleanedObjects.every((obj) => obj.status === 1);

    return {
        isValid,
        data: cleanedObjects,
    };
}

function filterValidPhoneNumbers(phoneNumbers) {
    // Regular expression to match 10-digit phone numbers
    let phoneRegExp = /^\d{10}$/;

    if (
        JSON.parse(sessionStorage.getItem("vendorData")).tenant_name ===
        "ultimatrue"
    ) {
        phoneRegExp = /^\d{12}$/;
    }

    // Filter the array to include only valid phone numbers
    const validPhoneNumbers = phoneNumbers.filter((number) =>
        phoneRegExp.test(number),
    );

    return validPhoneNumbers;
}

const BulkExtraPoints = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    const [CSVData, setCSVData] = useState(null);
    const [finalArray, setFinalArray] = useState([]);

    const [canSubmit, setCanSubmit] = useState(false);
    const [fileName, setFileName] = useState(null);

    useEffect(() => {
        if (CSVData && CSVData.parsed) {
            const res = validateAndCleanObjects(CSVData?.parsed);

            if (res.isValid) {
                setCanSubmit(true);
                setFinalArray(res.data);
            }
        }
    }, [CSVData]);

    const handleSendNotifications = (e) => {
        e.preventDefault();

        if (finalArray.length === 0) {
            toast.dismiss();
            toast.error("Csv format incorrect or data mismatch.", {
                id: "mismatchCsv&UserType",
            });
            return;
        }

        if (
            window.confirm(
                `Are you sure you want to add ${finalArray.length} entries for Bonus Points?`,
            )
        ) {
            handleOnSubmit(e);
        } else {
            toast.dismiss();
            return;
        }
    };

    const [
        uploadBonusPoints,
        {
            data: bonusPointsData,
            error: bonusPointsError,
            isLoading: bonusPointsIsLoading,
        },
    ] = useBulkExtraBonusPointsMutation();

    const handleOnSubmit = (e) => {
        e.preventDefault();
        uploadBonusPoints({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: {
                transfers: finalArray,
            },
        });
    };

    useEffect(() => {
        if (bonusPointsData) {
            toast.dismiss();
            toast.success("Saved Successfully", {
                id: "bonusPointsData",
            });
            // console.log("bonusPointsData", bonusPointsData);

            if (bonusPointsData.body && bonusPointsData.body.failed && bonusPointsData.body.failed.length > 0) {
                console.log("failedEntries", bonusPointsData.body.failed);
                downloadCSV(bonusPointsData.body.failed, "FailedEntriesBonusPoints.csv");
            }

            setTimeout(() => {
                navigate(`/genefied/${getVendorName()}/extra-points-history`);
            }, 400);
        }

        if (bonusPointsError) {
            // console.log("bonusPointsError", bonusPointsError);
            toast.dismiss();
            if (bonusPointsError.status == 400) {
                toast.error(`Bad Request : ${bonusPointsError.data.message}`);
            } else {
                toast.error(`Something went wrong`);
            }
        }
    }, [bonusPointsData, bonusPointsError]);

    return (
        <div className="flex w-full bg-gray-200 h-full justify-center">
            <div className="w-full ">
                <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                    Add Bonus Points / Extra Points
                    <LinksComponent />
                </div>
                <div className="mx-9 mt-6">
                    <div className="flex space-x-3">
                        <div className="flex mb-1">
                            <button
                                type="submit"
                                className="mb-2 text-white bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-1.5 text-center "
                                onClick={() =>
                                    downloadCSV(
                                        sampleData,
                                        "sampleUploadBonusPoints.csv",
                                    )
                                }
                            >
                                Sample Upload Csv
                            </button>
                        </div>
                    </div>

                    <form className="bg-white shadow-md rounded-lg flex w-full p-6 justify-center max-w-full mx-auto">
                        <div className="w-full flex flex-col justify-center items-center">
                            <div className="w-full max-w-xl flex flex-col items-center">
                                <div className="w-full flex flex-col items-center">
                                    <label className="block text-gray-600 text-sm mb-2">
                                        Upload CSV File:
                                    </label>
                                    <CSVReader
                                        setCSVData={setCSVData}
                                        setFileName={setFileName}
                                    />
                                </div>

                                <div className="flex justify-center space-x-4 mt-6">
                                    {canSubmit && (
                                        <>
                                            <button
                                                type="button"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setShowModal(true);
                                                }}
                                                className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-6 py-2.5"
                                            >
                                                View CSV File
                                            </button>

                                            {bonusPointsIsLoading ? (
                                                <button
                                                    className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-6 py-2.5 disabled:opacity-50 flex items-center justify-center"
                                                    disabled
                                                >
                                                    <svg
                                                        className="animate-spin h-6 w-6 text-white"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                    >
                                                        <circle
                                                            cx="12"
                                                            cy="12"
                                                            r="10"
                                                            stroke="currentColor"
                                                            strokeWidth="4"
                                                            fill="none"
                                                            strokeLinecap="round"
                                                        />
                                                        <path
                                                            fill="currentColor"
                                                            d="M4 12a8 8 0 018-8v16a8 8 0 01-8-8z"
                                                        />
                                                    </svg>
                                                </button>
                                            ) : (
                                                <button
                                                    type="submit"
                                                    onClick={(e) =>
                                                        handleSendNotifications(
                                                            e,
                                                        )
                                                    }
                                                    disabled={!canSubmit}
                                                    className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-6 py-2.5 disabled:opacity-50"
                                                >
                                                    Save
                                                </button>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                {showModal && finalArray && (
                    <ModalComponent
                        size={"5xl"}
                        data={""}
                        show={showModal}
                        setShow={setShowModal}
                    >
                        <div className="w-full rounded-lg">
                            <div className=" w-full border-opacity-40 rounded-lg p-4 mt-2">
                                <div className="overflow-x-auto">
                                    <table className="min-w-full bg-white border border-gray-300">
                                        <thead>
                                            <tr>
                                                {(finalArray.length > 0
                                                    ? Object.keys(finalArray[0])
                                                    : []
                                                ).map((column, index) => (
                                                    <th
                                                        key={index}
                                                        className="py-2 px-4 border-b uppercase"
                                                    >
                                                        {column}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {finalArray
                                                .slice(0, 40)
                                                .map((item, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        {(finalArray.length > 0
                                                            ? Object.keys(
                                                                finalArray[0],
                                                            )
                                                            : []
                                                        ).map(
                                                            (
                                                                column,
                                                                colIndex,
                                                            ) => (
                                                                <td
                                                                    key={
                                                                        colIndex
                                                                    }
                                                                    className="py-2 px-4 border-b"
                                                                >
                                                                    {
                                                                        item[
                                                                        column
                                                                        ]
                                                                    }
                                                                </td>
                                                            ),
                                                        )}
                                                    </tr>
                                                ))}

                                            <h2 className="mt-2 ml-auto">
                                                {" "}
                                                {finalArray.length > 40
                                                    ? `${finalArray.length - 40
                                                    } rows more`
                                                    : ` `}
                                            </h2>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </ModalComponent>
                )}
            </div>
        </div>
    );
};

export default BulkExtraPoints;

const sampleData = [
    {
        mobile: "9878987890",
        points: 1000,
        remarks: "Bonus Points",
    },
    {
        Mobile: "9878987110",
        Points: 200,
        remarks: "Bonus Points",
    },
    {
        Mobile: "9878998980",
        Points: 50,
        remarks: "Bonus Points",
    },
];
